import React, { useEffect, useState } from 'react';
import {
  Button,
  DatePicker,
  Form,
  Select,
  Table,
} from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import LzPagination from '@/components/common/LzPagination';
import { Servlets } from '@/service';
import DataExport from '@/components/DataExport';
import LzDialog from '@/components/common/LzDialog';
import SecondaryMarketCrowd from '@/components/crowd/SecondaryMarketCrowd';

export default (props) => {
  // 表单
  const FormItem = Form.Item;
  // // 搜索参数
  // const [searchParams, setSearchParams] = useState(
  //   {
  //     "count": "",
  //     "detail": "",
  //     "modelId": 0,
  //     "modelType": "订单催付",
  //     "outerName": "",
  //   }
  // )
  // 时间选择器
  const { RangePicker, MonthPicker, YearPicker, WeekPicker } = DatePicker;
  // 表格数据
  const [TableData, setTableData] = useState();
  // const TableData = [{
  //   "payNum":11,
  //   "launchEndTime":198923324343,
  //   "launchTime":1989233243434,
  //   "campaignName":100,
  //   "campaignModel":2,
  //   "remark":"ewewe",
  //   "sendSuccessValue":12,
  //   "expectSendAmount":111
  //   }]
  // 导出是否显示
  const [dataExportVisible, setDataExportVisible] = useState(false);
  // 生成任务人群是否显示
  const [dutyCrowdVisible, setDutyCrowdVisible] = useState(false);
  // 生成任务人群
  const [refrshParams, setRefreshParams] = useState({
    crowdDesc: '',
    crowdName: '',
    id: '',
  });
  // 子组件关闭
  const onExportVisible = () => {
    setDataExportVisible(false);
  };
  // 批量导出列表
  const [exportList, setExportList] = useState([]);
  // 选中个数
  const [chooseNum, setChooseNum] = useState(0);
  // 请求参数获取
  const [fetchParams, setFetchParams] = useState({
    executeStart: '',
    executeEnd: '',
    packStatus: '',
    pageNo: 1,
    pageSize: 10,
  });
  // 搜索参数
  const [searchParams, setSearchParams] = useState({
    executeStart: '',
    executeEnd: '',
    packStatus: '',
  });
  // 人群
  const [secondaryMarketCrowdData, setSecondaryMarketCrowdData] = useState();
  // 二次营销子组件关闭
  const secondaryClose = () => {
    setSecondaryVisible(false);
  };
  // 是否显示 生成二次营销人群
  const [secondaryVisible, setSecondaryVisible] = useState(false);
  // 查询参数：执行状态下拉列表
  const status = [
    { value: '', label: '全部状态' },
    { value: 1, label: '执行中' },
    { value: 2, label: '执行成功' },
    { value: 3, label: '执行失败' },
  ];
  const openData = (row) => {
    if (
      row.name &&
      row.activityInstId &&
      row.taskId &&
      row.taskInstId &&
      row.launchTime
    ) {
      // row.name = row.name.replace("#","%23").replace("&","%26").replace("=","%3D").replace("?","%3F").replace("/","%2F").replace("+","%2B");
      row.name = encodeURIComponent(row.name);
      let ConstantUrl = 'market/custom/marketing/resultsData';
      if (props.fromUrl === 'web') {
        ConstantUrl = `${props.fromUrl}${ConstantUrl}`;
      }
      window.open(
        `../../../${ConstantUrl}/${row.name}/${row.activityInstId}/${row.taskId}/${row.taskInstId}/${row.launchTime}/0/1`
      );
    } else {
      LzMsg.error('所需参数不全，无法展示效果数据');
    }
  };

  // 分页信息
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      // TODO 请求后端列表接口
      getExecution({
        pageSize: pages.pageSize,
        pageNo: pages.pageNo,
        executeStart: searchParams.executeStart,
        executeEnd: searchParams.executeEnd,
        packStatus: searchParams.packStatus,
      });
    } catch (e) {}
  };
  // 查询
  const search = (values, errors) => {
    fetchParams.packStatus = values.packStatus ? values.packStatus : '';
    fetchParams.executeStart =
      values.year && values.year[0] ? values.year[0]._d.getTime() : '';
    fetchParams.executeEnd =
      values.year && values.year[1] ? values.year[1]._d.getTime() : '';
    fetchParams.pageSize = pageInfo.pageSize;
    pageInfo.pageNo = 1;
    getExecution(fetchParams);
    setSearchParams(fetchParams);
  };

  // 初始化渲染
  useEffect(() => {
    getExecution({ pageNo: 1, pageSize: pageInfo.pageSize });
  }, []);

  // 获得公域短信记录
  const getExecution = (params) => {
    // 接收参数
    const formData = {
      executeStart: params.executeStart,
      executeEnd: params.executeEnd,
      packStatus: params.packStatus,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      id: props.excuteId,
      ...params,
    };
    // 请求接口
    Servlets('getAutoModelMarketExcuteLog', formData)
      .then((res) => {
        setTableData(res.data);
        // 分页参数更新
        setPageInfo({
          ...pageInfo,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
          total: res.page.total,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const defaultTimeValues = [
    moment("00:00:00", "HH:mm:ss", true),
    moment("23:59:59", "HH:mm:ss", true)
  ];
  return (
    <div>
      <div className="excute-form">
        <Form className={styles.search} style={{ width: '100%' }}>
          <div style={{ display: 'flex', height: '60px' }}>
            <FormItem style={{ width: '40%' }} label="执行时间：">
              <RangePicker
                placeholder={['开始时间', '结束时间']}
                style={{ width: '95%' }}
                name="year"
                showTime={{ defaultValue: defaultTimeValues, format: 'HH:mm:ss' }}
                resetTime
                followTrigger
                onChange={(value) => {
                  value[0]
                    ? setFetchParams({
                        ...fetchParams,
                        executeStart: value[0]._d.getTime(),
                      })
                    : '';
                  value[1]
                    ? setFetchParams({
                        ...fetchParams,
                        executeEnd: value[1]._d.getTime(),
                      })
                    : '';
                }}
              />
            </FormItem>
            <FormItem style={{ width: '35%' }} label="活动状态：">
              <Select
                name="packStatus"
                followTrigger
                dataSource={status}
                style={{ width: '100%', borderRadius: '2px 2px 2px 2px' }}
              />
            </FormItem>
            <FormItem
              style={{ textAlign: 'right', width: '25%', paddingTop: '28px' }}
            >
              <Form.Submit
                type="primary"
                className={styles.btn}
                onClick={search}
              >
                查询
              </Form.Submit>
              <Form.Reset
                type="normal"
                className={styles.btn}
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  setSearchParams({
                    executeStart: '',
                    executeEnd: '',
                    packStatus: '',
                  });
                  getExecution({
                    executeStart: '',
                    executeEnd: '',
                    packStatus: '',
                    pageNo: 1,
                    pageSize: 10,
                  });
                }}
              >
                重置
              </Form.Reset>
            </FormItem>
          </div>
        </Form>
        <div style={{ width: '100%', textAlign: 'right', paddingTop: '10px' }}>
          <Button
            type="primary"
            style={{ marginLeft: '10px' }}
            className={styles.btn}
            onClick={() => {
              if (chooseNum === 0) {
                // 回到顶部
                parent.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                LzMsg.error('请选择要导出的任务');
              } else {
                setDataExportVisible(true);
              }
            }}
          >
            批量导出
          </Button>
        </div>
        <div style={{ marginTop: '10px', marginBottom: '5px' }}>
          已选中<span style={{ color: '#FF3333' }}>{chooseNum}</span>项
        </div>
        <Table
          dataSource={TableData}
          style={{ width: '100%' }}
          primaryKey="taskInstId"
          fixedHeader
          maxBodyHeight={window.screen.height * 0.6 - 170}
          rowSelection={{
            // args 数组的0项是值  1 项是数据对象
            onChange: (...args) => {
              // 改变选中list的值
              setExportList(args[0]);
              // 选中的数量
              setChooseNum(args[0].length);
            },
            // 投放失败的任务，不可选中去导出
            getProps: (record, index) => {
              return (record.packStatus === 3 || record.packStatus === 1)
                ? {
                    disabled: true,
                  }
                : {

                  };
            },
            columnProps: () => {
              return {
                lock: 'left',
                align: 'center',
                name: 'select',
              };
            },
          }}
        >
          <Table.Column
            title="营销任务"
            cell={(index, value, record) => (
              <span>
                {moment(record.launchTime).format('MM-DD')}
                {record.name}
              </span>
            )}
          />
          <Table.Column
            title="执行时间"
            width={160}
            cell={(index, value, record) => (
              <span>
                {
                  moment(record.launchTime)
                    .format('YYYY-MM-DD HH:mm:ss')
                    .split(' ')[0]
                }{' '}
                {
                  moment(record.launchTime)
                    .format('YYYY-MM-DD HH:mm:ss')
                    .split(' ')[1]
                }
              </span>
            )}
          />
          <Table.Column
            title="预计触达人数（人）"
            width={150}
            cell={(index, value, record) => (
              <span>
                {record.expectSendAmount < 0 ||
                record.expectSendAmount === null ||
                record.expectSendAmount === '' ? (
                  <span>/</span>
                ) : record.expectSendAmount !== 0 ? (
                  record.expectSendAmount.toLocaleString()
                ) : (
                  0
                )}
              </span>
            )}
          />
          <Table.Column
            title="实际触达人数（人）"
            width={150}
            cell={(index, value, record) => (
              // 无数据或小于0时显示“/”，实际数据为0时，显示为0
              <span>
                {record.sendSuccessValue < 0 ||
                record.sendSuccessValue === null ||
                record.sendSuccessValue === '' ? (
                  <span>/</span>
                ) : record.sendSuccessValue !== 0 ? (
                  record.sendSuccessValue.toLocaleString()
                ) : (
                  0
                )}
              </span>
            )}
          />
          <Table.Column
            title="执行状态"
            cell={(index, value, record) => (
              <span>
                {record.packStatus === 1 && (
                  <span style={{ color: '#333333' }}>执行中</span>
                )}
                {record.packStatus === 2 && (
                  <span style={{ color: '#00BB66' }}>执行成功</span>
                )}
                {record.packStatus === 3 && (
                  <span style={{ color: '#FF3333' }}>执行失败</span>
                )}
              </span>
            )}
          />
          <Table.Column
            title="备注"
            cell={(index, value, record) => (
              <span>
                {record.remark ? (
                  <span style={{ color: '#FF3333' }}>{record.remark}</span>
                ) : (
                  <span>--</span>
                )}
              </span>
            )}
          />
          {
            props.executeType === 1 &&
            <Table.Column
            title="操作"
            cell={(item, value, record) => (
                <span>
                <Button
                    style={{
                    color: record.packStatus === 2 ? '#3399FF' : '#CCCCCC',
                    }}
                    type="primary"
                    text
                    // 只有执行成功才可以生成人群
                    disabled={record.packStatus !== 2}
                    /* takeType 4  短息 5 优惠促销 */
                    onClick={() => {
                    setSecondaryVisible(true);
                    setSecondaryMarketCrowdData({ ...record, taskType: 4 });
                    }}
                >
                    二次营销
                </Button>
                <br />
                <Button
                    style={{ color: '#3399FF' }}
                    type="primary"
                    text
                    onClick={() => openData(record)}
                    disabled={
                    !(
                        record.packStatus === 2 &&
                        Number(moment().format('x')) >
                        Number(
                            moment(record.launchTime)
                            .add(1, 'days')
                            .startOf('days')
                            .add(16, 'hours')
                            .format('x')
                        )
                    )
                    }
                >
                    效果数据
                </Button>
                </span>
            )}
            />
          }
        </Table>
        {/* 分页器 */}
        <div>
          <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
        </div>
      </div>

      <LzDialog
        visible={dataExportVisible}
        footer={false}
        shouldUpdatePosition
        title="数据导出"
        onClose={() => {
          setDataExportVisible(false);
        }}
        isFullScreen
        className="excute-dialog"
        style={{
          width: '1060px',
          minWidth: '900px',
        }}
      >
        {/* 是否是优惠促销 */}
        <DataExport onExportVisible={onExportVisible} taskInstId={exportList} />
      </LzDialog>
      {/* 生成任务人群 */}
      {/* 生成二次营销人群弹框 */}
      <LzDialog
        visible={secondaryVisible}
        shouldUpdatePosition
        title="生成二次营销人群"
        onClose={() => {
          setSecondaryVisible(false);
        }}
        style={{
          width: '1060px',
        }}
        className="crowd_second_market"
        footer={false}
        isFullScreen
      >
        {secondaryVisible && (
          <SecondaryMarketCrowd
            secondaryClose={secondaryClose}
            record={secondaryMarketCrowdData}
          />
        )}
      </LzDialog>
    </div>
  );
};
